import {
    IAnimationData,
    IAnimationPropertyData,
    IPropData
} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/animation/AnimationTypes';
import {PropPath} from '@mintdata/mint-kit/api/properties/PropPath';
import {ABoolean} from '@mintdata/mint-kit/api/values/ABoolean';

const relatedPropsUpdater = (animationData:IAnimationData, propData:IPropData, value:any) =>
{
    if( propData.prop )
    {
        const propPath:PropPath = PropPath.fromFieldPath('isEnabled');
        const isEnabled:ABoolean = propData.prop.getPropValue(propPath);

        if( !isEnabled || !isEnabled.value )
            propData.prop.setPropValue(propPath, ABoolean.true());
    }
};

export const basicData = (propertyPath:string,
                          cssProperty:string = null,
                          defaultFromValue:any = 0):IAnimationPropertyData => ({
    cssProperty,
    defaultFromValue,
    propertyPath,
    relatedPropsUpdater
});

